module.exports = __webpack_public_path__ + "static/img/hh-location.d39007ba.png";